/* unplugin-vue-components disabled */import script from "./Oppo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Oppo.vue?vue&type=script&setup=true&lang=ts"

import "./Oppo.vue?vue&type=style&index=0&id=50f04b12&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f04b12"]])

export default __exports__